module.exports = __webpack_public_path__ + "static/ru-sm-4-58d8fd0115a06298f07cccccd6c836f4.png";